const bkmxTopics: string[] = [
    'Accounting',
    'Acquired investment banks',
    'Activists',
    'Aerospace / defense',
    'Agreement reached',
    'Agriculture',
    'Airlines',
    'Announce plan',
    'Arts',
    'Automotive',
    'Bank loans',
    'Bankruptcy',
    'Bear / bull market',
    'Biology / chemistry / physics',
    'Bond yields',
    'Broadcasting',
    'Buffett',
    'Bush / Obama / Trump',
    'C-suite',
    'Cable',
    'California',
    'Canada / South Africa',
    'Casinos',
    'Challenges',
    'Changes',
    'Chemicals / paper',
    'China',
    'Clintons',
    'Committees',
    'Commodities',
    'Company spokesperson',
    'Competition',
    'Computers',
    'Connecticut',
    'Control stakes',
    'Convertible / preferred',
    'Corporate governance',
    'Corrections / amplifications',
    'Couriers',
    'Courts',
    'Credit cards',
    'Credit ratings',
    'Cultural life',
    'Currencies / metals',
    'Disease',
    'Drexel',
    'Earnings forecasts',
    'Earnings losses',
    'Earnings',
    'Economic growth',
    'Economic ideology',
    'Elections',
    'Electronics',
    'Environment',
    'European politics',
    'European sovereign debt',
    'Exchanges / composites',
    'Executive pay',
    'Fast food',
    'Federal Reserve',
    'Fees',
    'Financial crisis',
    'Financial reports',
    'Foods / consumer goods',
    'France / Italy',
    'Futures / indices',
    'Gender issues',
    'Germany',
    'Government budgets',
    'Health insurance',
    'Humor / language',
    'IPOs',
    'Immigration',
    'Indictments',
    'Insurance',
    'International exchanges',
    'Internet',
    'Investment banking',
    'Iraq',
    'Japan',
    'Job cuts',
    'Justice Department',
    'Key role',
    'Latin America',
    'Lawsuits',
    'Long / short term',
    'Luxury / beverages',
    'M&A',
    'Machinery',
    'Macroeconomic data',
    'Major concerns',
    'Management changes',
    'Marketing',
    'Mexico',
    'Microchips',
    'Mid-level executives',
    'Mid-size cities',
    'Middle east',
    'Mining',
    'Mobile devices',
    'Mortgages',
    'Movie industry',
    'Music industry',
    'Mutual funds',
    'NASD',
    'NY politics',
    'National security',
    'Natural disasters',
    'Negotiations',
    'News conference',
    'Nonperforming loans',
    'Nuclear / North Korea',
    'Oil drilling',
    'Oil market',
    'Optimism',
    'Options / VIX',
    'Pensions',
    'People familiar',
    'Pharma',
    'Phone companies',
    'Police / crime',
    'Political contributions',
    'Positive sentiment',
    'Private / public sector',
    'Private equity / hedge funds',
    'Problems',
    'Product prices',
    'Profits',
    'Programs / initiatives',
    'Publishing',
    'Rail / trucking / shipping',
    'Reagan',
    'Real estate',
    'Recession',
    'Record high',
    'Regulation',
    'Rental properties',
    'Research',
    'Restraint',
    'Retail',
    'Revenue growth',
    'Revised estimate',
    'Russia',
    'SEC',
    'Safety administrations',
    'Sales call',
    'Savings & loans',
    'Scenario analysis',
    'Schools',
    'Share payouts',
    'Short sales',
    'Size',
    'Small business',
    'Small caps',
    'Small changes',
    'Small possibility',
    'Soft drinks',
    'Software',
    'Southeast Asia',
    'Space program',
    'Spring / summer',
    'State politics',
    'Steel',
    'Subsidiaries',
    'Systems',
    'Takeovers',
    'Taxes',
    'Terrorism',
    'Tobacco',
    'Trade agreements',
    'Trading activity',
    'Treasury bonds',
    'UK',
    'US Senate',
    'US defense',
    'Unions',
    'Utilities',
    'Venture capital',
    'Watchdogs',
    'Wide range',
];

export default bkmxTopics;
